import { Component, inject } from '@angular/core';
import { AmlService } from '../_services/aml.service';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import { DialogService } from '../_services/dialog.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-error',
  standalone: true,
  imports: [MatButtonModule, CommonModule],
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss',
})
export class ErrorComponent {
  private dialogService = inject(DialogService);
  constructor() {
    //this.dialogService.onError('Errore', 'Errore generico');
  }
}
